import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const OnboardingChoosePlan: React.FC = () => {
  const [plan, setPlan] = useState('monthly');
  const navigate = useNavigate();

  const handleContinue = () => {
    // TODO: Stripe payment logic
    navigate('/onboarding/welcome');
  };

  return (
    <div className="max-w-md bg-white rounded-lg shadow p-8 mx-auto">
      <h2 className="text-2xl font-bold mb-6 text-center">Choose Your Plan</h2>
      <div className="mb-6 flex justify-center space-x-4">
        <button
          className={`px-6 py-3 rounded font-semibold border ${plan === 'monthly' ? 'bg-primary text-white' : 'bg-gray-100 text-gray-800'}`}
          onClick={() => setPlan('monthly')}
        >
          Monthly
        </button>
        <button
          className={`px-6 py-3 rounded font-semibold border ${plan === 'annual' ? 'bg-primary text-white' : 'bg-gray-100 text-gray-800'}`}
          onClick={() => setPlan('annual')}
        >
          Annual
        </button>
      </div>
      <button onClick={handleContinue} className="w-full bg-primary text-white py-2 rounded font-semibold">Continue</button>
    </div>
  );
};

export default OnboardingChoosePlan; 